import { render, staticRenderFns } from "./Emails.vue?vue&type=template&id=2573709c&scoped=true"
import script from "./Emails.vue?vue&type=script&lang=js"
export * from "./Emails.vue?vue&type=script&lang=js"
import style0 from "./Emails.vue?vue&type=style&index=0&id=2573709c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2573709c",
  null
  
)

export default component.exports